import { all, takeLatest, put } from 'redux-saga/effects';

import { types } from '@blueberry/redux/error';
import { actions } from '@blueberry/redux/auth';

import { TOKEN_INVALID_ERROR_CODE_REGEX } from '@blueberry/constants/errorCode';

export function* sendErrorFlow(action) {
  const { error } = action.payload;
  const { error_code: errorCode, statusCode } = error;

  if (TOKEN_INVALID_ERROR_CODE_REGEX.test(errorCode)) {
    yield put(actions.forceLogout(errorCode));

    return;
  }
  // meaning from api or record not found
  if (errorCode || statusCode === 404) {
    return;
  }
}

export default function*() {
  yield all([takeLatest(types.SEND_ERROR, sendErrorFlow)]);
}



// WEBPACK FOOTER //
// ./app/sagas/error.js